<template>
    <div class="flex w-full flex-col">
        <div class="flex items-center justify-center">
            <div :class="canvasClass">
                <canvas
                    ref="canvas"
                    class="block h-full w-full touch-none bg-white"
                />
            </div>
        </div>
        <div class="mt-4">
            {{ helpText }}
        </div>
        <prime-button
            class="mt-2 self-start"
            :label="t('purchaseContract.documentClearDrawing')"
            severity="secondary"
            outlined
            @click="clear"
        />
    </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import SignaturePad from 'signature_pad'
import PrimeButton from 'primevue/button'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
    helpText: string
    canvasClass: string
    initialData: string
}>()

const emit = defineEmits<{
    (e: 'data', payload: string): void
}>()

const { t } = useI18n({ useScope: 'global' })
const canvas = ref<HTMLCanvasElement>()
let signaturePad: SignaturePad | undefined
let currentData = props.initialData

function resizeCanvas() {
    if (signaturePad === undefined || canvas.value === undefined) {
        return
    }
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    canvas.value.width = canvas.value.offsetWidth * ratio
    canvas.value.height = canvas.value.offsetHeight * ratio
    canvas.value.getContext('2d')?.scale(ratio, ratio)
    signaturePad.clear()
    if (currentData !== '') {
        void signaturePad.fromDataURL(currentData)
    }
}

function clear() {
    signaturePad?.clear()
    currentData = ''
    emit('data', '')
}

onMounted(() => {
    signaturePad = new SignaturePad(canvas.value!)
    signaturePad.addEventListener('endStroke', () => {
        if (signaturePad === undefined) {
            return
        }
        currentData = signaturePad.isEmpty() ? '' : signaturePad.toDataURL()
        emit('data', currentData)
    })

    resizeCanvas()
    window.addEventListener('resize', resizeCanvas)
})

onUnmounted(() => {
    window.removeEventListener('resize', resizeCanvas)
    signaturePad?.off()
})
</script>
